import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../utils/massActions'
import {
  getEntityActionTypeSelectOptions,
  isEditEntityActionType,
} from '../Entity'

import {
  REQUEST_ACTION_ARCHIVE_ITEM,
  REQUEST_ACTION_ASSIGN_ITEM,
  REQUEST_ACTION_CONNECT_DOC_FLOW_ITEM,
  REQUEST_ACTION_CONNECT_SERVICE_REQUEST_ITEM,
  REQUEST_ACTION_CREATE_DOC_FLOW_ITEM,
  REQUEST_ACTION_DUE_DATE_ITEM,
  REQUEST_ACTION_EDIT_CATEGORY_ITEM,
  REQUEST_ACTION_EDIT_LABEL_ITEM,
  REQUEST_ACTION_EDIT_PROVIDER_ITEM,
  REQUEST_ACTION_MARK_AS_PRIVATE,
  REQUEST_ACTION_MARK_AS_PUBLIC,
  REQUEST_ACTION_MARK_AS_READ,
  REQUEST_ACTION_MARK_AS_UNREAD,
  REQUEST_ACTION_RESTORE_ITEM,
  REQUEST_ACTION_UPDATE_STATUS_ITEM,
  REQUEST_ITEM_ACTION_TYPES,
} from './Request.constants.actions'
import {
  getIsRequestArchiveBlockedByStatus,
  getRequestArchiveBlockedByStatusTooltipProps,
} from './Request.utils.archive'

export function getItemActions({
  canConnectDocFlow,
  canCreateDocFlow,
  item,
  t,
  ukConfig,
}) {
  const { permissions, unread, visible_to_dwellers: isVisibleToDwellers } = item

  const isArchiveBlockedByStatus = getIsRequestArchiveBlockedByStatus({
    statusId: item.status,
    ukConfig,
  })

  const items = [
    {
      label: 'Request.EditAssigneeActionOptionKey',
      permission: permissions.can_edit_assignee,
      value: REQUEST_ACTION_ASSIGN_ITEM,
    },
    {
      label: 'Request.EditProviderActionOptionKey',
      permission: permissions.can_edit_contractors,
      value: REQUEST_ACTION_EDIT_PROVIDER_ITEM,
    },
    {
      label: 'Request.ChangeStatusActionOptionKey',
      permission: permissions.can_edit_status,
      value: REQUEST_ACTION_UPDATE_STATUS_ITEM,
    },
    {
      label: 'Request.ChangeDeadlineActionOptionKey',
      permission: permissions.can_edit_due_date,
      value: REQUEST_ACTION_DUE_DATE_ITEM,
    },
    {
      label: 'Request.EditLabelActionOptionKey',
      permission: permissions.can_edit_labels,
      value: REQUEST_ACTION_EDIT_LABEL_ITEM,
    },
    {
      label: 'Request.EditCategoryActionOptionKey',
      permission: permissions.can_edit_category,
      value: REQUEST_ACTION_EDIT_CATEGORY_ITEM,
    },
    {
      label: 'Request.ConnectServiceRequestsActionOptionKey',
      permission: permissions.can_add_connected_requests,
      value: REQUEST_ACTION_CONNECT_SERVICE_REQUEST_ITEM,
    },
    {
      label: 'Request.ConnectDocFlowActionOptionKey',
      permission: canConnectDocFlow,
      value: REQUEST_ACTION_CONNECT_DOC_FLOW_ITEM,
    },
    {
      label: 'Request.CreateDocFlowActionOptionKey',
      permission: canConnectDocFlow && canCreateDocFlow,
      value: REQUEST_ACTION_CREATE_DOC_FLOW_ITEM,
    },
    {
      label: 'Request.MarkAsUnreadActionOptionKey',
      permission: permissions.can_edit_unread_status && !unread,
      value: REQUEST_ACTION_MARK_AS_UNREAD,
    },
    {
      label: 'Request.MarkAsReadActionOptionKey',
      permission: permissions.can_edit_unread_status && unread,
      value: REQUEST_ACTION_MARK_AS_READ,
    },
    {
      label: 'Request.MarkAsPublicActionOptionKey',
      permission:
        permissions.can_edit_visibility_to_dwellers && !isVisibleToDwellers,
      value: REQUEST_ACTION_MARK_AS_PUBLIC,
    },
    {
      label: 'Request.MarkAsPrivateActionOptionKey',
      permission:
        permissions.can_edit_visibility_to_dwellers && isVisibleToDwellers,
      value: REQUEST_ACTION_MARK_AS_PRIVATE,
    },
    null,
    {
      ...getRequestArchiveBlockedByStatusTooltipProps({
        isBlocked: isArchiveBlockedByStatus,
        statusId: item.status,
        t,
      }),
      disabled: isArchiveBlockedByStatus,
      label: 'Request.ArchiveActionOptionKey',
      permission: permissions.can_archive,
      value: REQUEST_ACTION_ARCHIVE_ITEM,
    },
    {
      label: 'Request.RestoreActionOptionKey',
      permission: permissions.can_restore,
      value: REQUEST_ACTION_RESTORE_ITEM,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getRequestItemActionTypes(
  availableTypes = REQUEST_ITEM_ACTION_TYPES
) {
  return Object.values(getEntityActionTypeSelectOptions()).filter(item =>
    availableTypes.includes(item.value)
  )
}

export function getRequestMassActionTypes() {
  return Object.values(getEntityActionTypeSelectOptions())
}

export function getRequestEditStatusActionTypes() {
  return Object.values(getEntityActionTypeSelectOptions()).filter(
    isEditEntityActionType
  )
}
